import { h } from 'preact'

import Message from './Message'
import Response from './Response'

const History = ({messages, data, timestamps}) => (
  <div>
    {messages.map(m => (
      <div key={m.id}>
        <Message message={m.question} data={data} isHistory={true} timestamp={timestamps[m.id]} />
        <Response answer={m.answer} />
      </div>
    ))}
  </div>
)

export default History



// WEBPACK FOOTER //
// ./components/ChatBot/History.js